/**
 * Financial Planner Page
 * 
 * This page displays the interactive financial planner component
 * for home purchase and retirement planning.
 */

import React from 'react';
import FinancialPlanner from '../components/FinancialPlanner';

export function FinancialPlannerPage(): React.ReactElement {
  return (
    <div id="main-content" className="min-h-screen">
      <FinancialPlanner />
    </div>
  );
}

export default FinancialPlannerPage;
